import { CheckoutPageId } from 'checkout/constants/pages'

export function hasCruiseBundleRates(offer: App.CruiseOffer): boolean {
  return !!offer.bundle?.rateCodes.length
}

export function getCruiseInitialOccupancy(offer: App.CruiseOffer): App.Occupants {
  if (hasCruiseBundleRates(offer)) {
    return { adults: 2, children: 0, infants: 0 }
  }

  return { adults: 0, children: 0, infants: 0 }
}

export function getCruiseInitialCheckoutStep(offer: App.CruiseOffer): CheckoutPageId {
  return hasCruiseBundleRates(offer) ? CheckoutPageId.CruiseCabinType : CheckoutPageId.CruiseTravelers
}
